import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getReportSummary, getReportSummaryFailure, getReportSummaryIdle, getReportSummarySuccess } from '../actions';

const status_get_report_summary = handleActions(
  {
    [getReportSummary.toString()]: (state, action) => 'LOADING',
    [getReportSummarySuccess.toString()]: (state, action) => 'SUCCESS',
    [getReportSummaryFailure.toString()]: (state, action) => 'FAILURE',
    [getReportSummaryIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_report_summary = handleActions(
  {
    [getReportSummary.toString()]: () => null,
    [getReportSummarySuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { status_get_report_summary, data_get_report_summary };
